
/**
 * @file Signup reducer
 * @author Denny K. Schuldt
 * @copyright Copyright 2017, Datilmedia S.A.
 */

import Immutable, {Map} from 'immutable';
import * as types from '../constants/action-types'
import * as errors from '../constants/error-types'

const initialState = Map({
  data: Map({
    username: "",
    email: "",
    password: "",
    src: "",
    planFee: "",
    planCode: "",
    promo: "",
    referral_code : ""
  }),
  validations: Map({
    localUsername: "",
    localEmail: "",
    password: "",
    remoteUsername: "",
    remoteEmail: ""
  }),
  validating: Map({
    username: false,
    email: false
  }),
  valid: false,
  submitting: false,
  error: ""
})


/**
 *
 */
function updateError(state, action) {
  switch (action.payload.error) {
    case "104":
      return state.set("error", errors.USERNAME_ALREADY_EXISTS_ERROR + " " + action.payload.username)
    case "105":
      return state.set("error", errors.EMAIL_ALREADY_EXISTS_ERROR + " " + unescape(action.payload.email))
    case "106":
      return state.set("error", errors.SERVICE_NOT_AVAILABLE_ERROR)
    case "107":
      return state.set("error", errors.SERVICE_NOT_AVAILABLE_ERROR)
    case "108":
      return state.set("error", errors.PASSWORD_NOT_VALID)
    case "500":
      return state.set("error", errors.SERVICE_NOT_AVAILABLE_ERROR)
    default:
      return state;
  }
}

/**
 *
 */
function changeUsername(state, action) {
  return state.setIn(['data', 'username'], action.payload.username)
}

/**
 *
 */
function changeEmail(state, action) {
  return state.setIn(['data', 'email'], action.payload.email)
}

/**
 *
 */
function changePassword(state, action) {
  return state.setIn(['data', 'password'], action.payload.password)
}

/**
 *
 */
function changeSrc(state, action) {
  return state.setIn(['data', 'src'], action.payload.src)
}

/**
 *
 */
function changePlanFee(state, action) {
  return state.setIn(['data', 'planFee'], action.payload.planFee)
}

/**
 *
 */
function changePlanCode(state, action) {
  return state.setIn(['data', 'planCode'], action.payload.planCode)
}

/**
 *
 */
function changePromo(state, action) {
  return state.setIn(['data', 'promo'], action.payload.promo)
}

/**
 *
 */
function validateUsername(state) {

  const reWhiteSpace = /\s/;
  const reIsAscii = /^[\x00-\x7F]*$/;

  if (reWhiteSpace.test(state.getIn(['data', 'username']))) {
    return state.setIn(['validations', 'localUsername'], errors.USERNAME_NO_WHITE_SPACE_ERR)
  }
  if (!reIsAscii.test(state.getIn(['data', 'username']))) {
    return state.setIn(['validations', 'localUsername'], errors.USERNAME_NO_ACCENT_MARK_ERR)
  }
  if (!state.getIn(['data', 'username']).length) {
    return state.setIn(['validations', 'localUsername'], errors.USERNAME_EMPTY_ERR)
  }
  if (state.getIn(['validations', 'username']) != errors.USERNAME_NOT_AVAILABLE_ERR) {
    return state.setIn(['validations', 'localUsername'], '')
  }
  return state.setIn(['validations', 'localUsername'], '');
}

/**
 *
 */
function validateEmail(state) {
  const reEmail = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

  if (!reEmail.test(state.getIn(['data', 'email']))) {
    return state.setIn(['validations', 'localEmail'], errors.EMAIL_NOT_VALID_ERR)
  }
  if (!state.getIn(['data', 'email']).length) {
    return state.setIn(['validations', 'localEmail'], errors.EMAIL_EMPTY_ERR)
  }
  return state.setIn(['validations', 'localEmail'], "")
}

/**
 *
 */
function validatePassword(state) {
  if (!state.getIn(['data', 'password']).length) {
    return state.setIn(['validations', 'password'], errors.PASSWORD_EMPTY_ERR)
  }
  if (state.getIn(['data', 'password']).length < 8) {
    return state.setIn(['validations', 'password'], errors.PASSWORD_NOT_VALID_LENGTH_ERR)
  }
  const rePassword = /^[\S]+.*[\S]+$/;
  if (!rePassword.test(state.getIn(['data', 'password']))) {
    return state.setIn(['validations', 'password'], errors.PASSWORD_NOT_VALID_PATTERN_ERR)
  }
  const reUppercase = /.*[A-Z].*/;
  if (!reUppercase.test(state.getIn(['data', 'password']))) {
    return state.setIn(['validations', 'password'], errors.PASSWORD_NOT_VALID_NOT_UPPER)
  }
  const reNumber = /.*\d.*/;
  if (!reNumber.test(state.getIn(['data', 'password']))) {
    return state.setIn(['validations', 'password'], errors.PASSWORD_NOT_VALID_NOT_NUMBER)
  }
  return state.setIn(['validations', 'password'], '')
}

/**
 *
 */
function validateForm(state) {
  state = validateUsername(
            validateEmail(
              validatePassword(state)
            )
          )
  if (state.getIn(['validations', 'localUsername']).length ||
      state.getIn(['validations', 'remoteUsername']).length ||
      state.getIn(['validations', 'localEmail']).length ||
      state.getIn(['validations', 'remoteEmail']).length ||
      state.getIn(['validations', 'password']).length) {
    return state.set('valid', false)
  }
  return state.set('valid', true)
}

/**
 *
 */
function requestFormSubmitStarted(state) {
  return state.set('submitting', true)
}

/**
 *
 */
function requestUsernameAvailableStarted(state) {
  return state.setIn(['validating', 'username'], true)
              .setIn(['validations', 'remoteUsername'], '')
}

/**
 *
 */
function requestUsernameAvailableSucceed(state, action) {
  return state.setIn(['validating', 'username'], false)
              .setIn(['validations', 'remoteUsername'], '')
}

/**
 *
 */
function requestUsernameAvailableFailed(state, action) {
  return state.setIn(['validating', 'username'], false)
              .setIn(['validations', 'remoteUsername'], errors.USERNAME_NOT_AVAILABLE_ERR)
}

/**
 *
 */
function requestUsernameAvailableIsEmailFailed(state, action) {
  return state.setIn(['validating', 'username'], false)
              .setIn(['validations', 'remoteUsername'], errors.USERNAME_IS_A_EMAIL_ERR)
}

/**
 *
 */
function requestEmailAvailableStarted(state) {
  return state.setIn(['validating', 'email'], true)
              .setIn(['validations', 'remoteEmail'], '')
}

/**
 *
 */
function requestEmailAvailableSucceed(state, action) {
  return state.setIn(['validating', 'email'], false)
              .setIn(['validations', 'remoteEmail'], '')
}

/**
 *
 */
function requestEmailAvailableFailed(state, action) {
  return state.setIn(['validating', 'email'], false)
              .setIn(['validations', 'remoteEmail'], errors.EMAIL_NOT_AVAILABLE_ERR)
}


function setReferralCode(state, action){
  return state.setIn(['data', 'referral_code'], action.payload.referral_code)
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_ERROR:
      return updateError(state, action)
    case types.CHANGE_USERNAME:
      return changeUsername(state, action)
    case types.CHANGE_EMAIL:
      return changeEmail(state, action)
    case types.CHANGE_PASSWORD:
      return changePassword(state, action)
    case types.CHANGE_SRC:
      return changeSrc(state, action)
    case types.CHANGE_PLAN_FEE:
      return changePlanFee(state, action)
    case types.CHANGE_PLAN_CODE:
      return changePlanCode(state, action)
    case types.CHANGE_PROMO:
      return changePromo(state, action)
    case types.VALIDATE_USERNAME:
      return validateUsername(state)
    case types.VALIDATE_EMAIL:
      return validateEmail(state)
    case types.VALIDATE_PASSWORD:
      return validatePassword(state)
    case types.VALIDATE_FORM:
      return validateForm(state)
    case types.REQUEST_FORM_SUBMIT_STARTED:
      return requestFormSubmitStarted(state)
    case types.REQUEST_USERNAME_AVAILABLE_STARTED:
      return requestUsernameAvailableStarted(state)
    case types.REQUEST_USERNAME_AVAILABLE_SUCCEED:
      return requestUsernameAvailableSucceed(state, action)
    case types.REQUEST_USERNAME_AVAILABLE_FAILED:
      return requestUsernameAvailableFailed(state, action)
    case types.REQUEST_USERNAME_IS_A_EMAIL_FAILED:
      return requestUsernameAvailableIsEmailFailed(state, action)
    case types.REQUEST_EMAIL_AVAILABLE_STARTED:
      return requestEmailAvailableStarted(state)
    case types.REQUEST_EMAIL_AVAILABLE_SUCCEED:
      return requestEmailAvailableSucceed(state, action)
    case types.REQUEST_EMAIL_AVAILABLE_FAILED:
      return requestEmailAvailableFailed(state, action)
    case types.SET_REFERRAL_CODE:
      return setReferralCode(state, action)
    default:
      return state
  }
}
